/**
 * Public entrypoint for the PlayerDetailErrorState component — the recoverable
 * "Something went wrong" + retry surface shown when the player-detail query
 * aborts or errors instead of a blank screen (SE-5055).
 * @module features/player-detail/components/PlayerDetailErrorState
 */
export { default } from "./PlayerDetailErrorStateContainer";
